import script from "./Moreapps.vue?vue&type=script&setup=true&lang=js"
export * from "./Moreapps.vue?vue&type=script&setup=true&lang=js"

import "./Moreapps.vue?vue&type=style&index=0&id=3aceb17e&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aceb17e"]])

export default __exports__